export const GIGS_TO_SHOW = 2;
export const SECTION_NAME = 'post_message';
export const DEFAULT_SECTION_PROPS = {
    items: { gigs: [] },
    contextEnrichment: {
        context: {}
    }
};
